import moment from 'moment';

const countPeriods = (periodsLength, ticks) => {
    const periods = [];
    const time = (periodsLength === 24);
    for (let d = time ? 0 : (ticks ? 0 : 1); d <= periodsLength; d++ ) {
        let newValue = d.toString();
        newValue = time ? 
            (newValue.length < 2 ? `0${d}:00` : `${d}:00`) : 
            ((newValue.length < 2) ? `0${d}` : `${d}`);
        periods.push(newValue);
    }
    return periods;
};

const localPeriodLabels = {
    day: countPeriods(24),
    month: countPeriods(30),
    year: countPeriods(12)
};

export default {
    dateItems: ['day', 'month', 'year'],
    formats: {
        period: {
            day: "HH",
            month: "DD",
            year: "MM"
        },
        header: {
            day: 'MM/DD', 
            month: 'YYYY/MM', 
            year: 'YYYY'
        },
        render: {
            day: 'HH:SS', 
            month: 'MM/DD', 
            year: 'MM/YYYY'
        },
        winLoss: {
            day: "dailyPlayerWinLoss", 
            month: "last30PlayerWinLoss", 
            year: "last365PlayerWinLoss" 
        }
    },
    periodLabels: localPeriodLabels,
    periodTicks: {
        day: countPeriods(24, true),
        month: countPeriods(30, true),
        year: countPeriods(12, true)
    },
    data: {
        // labels: localPeriodLabels['day'],
        datasets: [
            {
                label: '',
                fill: false,
                lineTension: 0.1,
                borderColor: "#5AB9FF",
                borderWidth: 1,
                pointBorderColor: "rgba(11,94,155,0.5)",
                pointBackgroundColor: "#5AB9FF",
                pointBorderWidth: 3.5,
                pointHoverRadius: 7,
                pointHoverBackgroundColor: "#5AB9FF",
                pointHoverBorderColor: "rgba(11,94,155,0.9)",
                pointHoverBorderWidth: 5,
                pointRadius: 3,
                pointHitRadius: 10,
                steppedLine: 0,
                showLines: true,
                tooltips: false,
                data: [],
            }
        ],
        options: {
            scales: {
                xAxes: [
                    {
                        ticks: {
                            beginAtZero: false,
                            autoSkip: false
                        },
                        gridLines: {
                            drawOnChartArea: false,
                            lineWidth: 0,
                            display: "none",
                            drawBorder: false,
                        },
                    }
                ],
                yAxes: [
                    {
                        ticks: {
                            display: true,
                            beginAtZero: false,
                            suggestedMin: -10,
                            suggestedMax: 10,
                            stepSize: 5,
                            color: "#5AB9FF",
                            padding: 10
                        },
                        gridLines: {
                            color: "#5AB9FF",
                            drawBorder: false,
                            zeroLineColor: "#5AB9FF"
                        }
                    }
                ],
            },
            legend: { display: false },
            tooltips: {
                callbacks: {
                    title: function(tooltipItems, data) {
                        return data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index].x;
                    }
                }
            }
        }
    },
    initialDate: {
        day: {
            start: moment().format('YYYY/MM/DD'),
            end: moment().add(1, 'day').format('YYYY/MM/DD')
        },
        month: {
            start: moment().startOf('month').format('YYYY/MM/DD'),
            end: moment().endOf('month').add(1, 'day').format('YYYY/MM/DD')
        },
        year: {
            start: moment().startOf('year').format('YYYY/MM/DD'),
            end: moment().endOf('year').add(1, 'day').format('YYYY/MM/DD')
        }
    },
    defaultTicks: {
        x: {
            display: true,
            beginAtZero: false,
            autoSkip: false
        },
        y: {
            suggestedMin: -10,
            suggestedMax: 10,
            stepSize: 5,
        }
    },
    defaultLabels: {
        day: ['00:00', '24:00'],
        month: ['01', '05', '10', '15', '20', '25', '30'],
        year: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    },
    gameTypes: [{label: 'all', productId: [5,8,9]}, {label: 'poker', productId: 5}, {label: 'casino', productId: 8}, {label: 'betting', productId: 9}]
}